module.exports = __webpack_public_path__ + "images/emoji/mountain_cableway.d0ddf1c925d7bf8617d2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mountain_cableway.png
// module id = +QOt
// module chunks = 1